import {
  GET,
  GET_FULFILLED,
  GET_REJECTED,
} from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getErrorStringFromServerError } from "@icarius-localization/strings";
import { getCollaboratorSkillsRankingAPI } from "@icarius-connection/api";

export const getCollaboratorSkillsRankingAction = () => async (dispatch) => {
  dispatch({ type: GET });

  try {
    const response = await getCollaboratorSkillsRankingAPI();

    const summary = response.data?.summary;
    const skillMatrix = response.data?.skillMatrix;
    const suggestions = response.data?.suggestions;

    dispatch({
      type: GET_FULFILLED,
      payload: {
        summary,
        skillMatrix,
        suggestions,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: GET_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};